import React from 'react';
import { useHistory } from 'react-router-dom';
import { Alert, Button } from '..';
import routeConfiguration from '../../routeConfiguration';
import { createResourceLocatorString } from '../../util/routes';
import css from './Alert.css';
import config from '../../config';
import classNames from 'classnames';

const { userTypeRider } = config;

const AlertProfileNotComplete = () => {
    const history = useHistory();

    return (
        <Alert
            showAsPlainText
            closeAllowed
            header="Profil unvollständig"
            description="Vervollständige dein Profil, um Zusatzpakete zu aktivieren."
            rootClassName={classNames(css.alert, css.alertProfile)}
            closeClassName={css.closeButton}
        >
            <Button
                type="button"
                onClick={() =>
                    history.push(
                        createResourceLocatorString('ProfileSettingsPage', routeConfiguration(), {
                            userType: userTypeRider,
                        })
                    )
                }
            >
                Profil bearbeiten
            </Button>
        </Alert>
    );
};

export default AlertProfileNotComplete;
